// Icônes au trait, 24 px, dessinées pour être lisibles en plein soleil (trait de 2 px).
import type { SVGProps } from 'react';

const base = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const;

type Props = SVGProps<SVGSVGElement>;

export const IconClose = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const IconLocate = (p: Props) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="7" />
    <circle cx="12" cy="12" r="2.5" fill="currentColor" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
  </svg>
);

export const IconRoute = (p: Props) => (
  <svg {...base} {...p}>
    <circle cx="6" cy="18" r="2.5" />
    <path d="M8.5 18H15a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h7" />
    <path d="M14 1.5L16.5 4 14 6.5" />
  </svg>
);

export const IconWalk = (p: Props) => (
  <svg {...base} {...p}>
    <circle cx="13" cy="4" r="2" />
    <path d="M10 22l2-7 3 3v4M7 12l3-4 4 1 2 4 3 1M10 8l-1 6" />
  </svg>
);

export const IconChevronUp = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M6 15l6-6 6 6" />
  </svg>
);

export const IconArrowLeft = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M19 12H5M11 6l-6 6 6 6" />
  </svg>
);

export const IconPlus = (p: Props) => (
  <svg {...base} {...p} viewBox="0 0 16 16" width={16} height={16}>
    <path d="M8 3.5v9M3.5 8h9" />
  </svg>
);

export const IconMinus = (p: Props) => (
  <svg {...base} {...p} viewBox="0 0 16 16" width={16} height={16}>
    <path d="M3.5 8h9" />
  </svg>
);

export const IconMenu = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const IconChevronRight = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);

export const IconDownload = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
  </svg>
);

export const IconTrash = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6" />
  </svg>
);

export const IconCloudOff = (p: Props) => (
  <svg {...base} {...p}>
    <path d="M3 3l18 18M8 8a5 5 0 0 0-1 0 4 4 0 0 0 0 8h10M19 16a3.5 3.5 0 0 0-2.5-6 5 5 0 0 0-6-3.6" />
  </svg>
);
